<div id="main-container">
  <app-mcp-billing *ngIf="mcpBilling.active"></app-mcp-billing>
  <app-mcp-provider-connection *ngIf="mcpProvider.active"></app-mcp-provider-connection>
  <router-outlet *ngIf="!mcpBilling.active && !mcpProvider.active && !mcpEmbed.blocked"></router-outlet>
  <p *ngIf="mcpEmbed.plansPending && !mcpEmbed.blocked" role="status">Opening Payments and Plans…</p>
  <p *ngIf="mcpEmbed.blocked" role="status">{{ mcpEmbed.status }}</p>
</div>
<app-confirm-dialog></app-confirm-dialog>
<button
  id="modal-btn"
  hidden
  type="button"
  class="btn btn-primary"
  data-toggle="modal"
  data-target="#addToHomeScreenModal"
></button>

<div
  class="modal fade"
  id="addToHomeScreenModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addToHomeScreenModalTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="logo-img" layout-align="center">
          <img
            src="../assets/icons/appicon/ic_mangomirror_hdpi.png"
            width="45"
            alt=""
          />
        </div>
        <div class="header">
          <strong>{{ "PWAPOPUP.TITLE" | translate }}</strong>
        </div>
        <p>
          {{ "PWAPOPUP.TEXT1" | translate }}
        </p>
        <div class="footer">
          <p>
            {{ "PWAPOPUP.TEXT2" | translate }}
            <img src="../assets/icons/share-icon-ios.jpg" alt="" width="15" />
            {{ "PWAPOPUP.TEXT3" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  type="ball-spin-clockwise"
  size="default"
  color="#fff"
  [fullScreen]="true"
>
  <p class="spinner-text-color">Please wait...</p>
</ngx-spinner>
